import { scrollIntoView } from '@/npm/scrollIntoView.js';
import noop from 'lodash/noop.js';
import { useMemo } from 'react';
import { useCallback } from 'react';
import { useRef } from 'react';
import { ScrollAnchor } from '../../../base-components/ScrollAnchor.js';

interface UseScrollToAnchor {
  (): [JSX.Element, () => void];
}

export const useScrollToAnchor: UseScrollToAnchor = () => {
  const anchorRef = useRef<HTMLDivElement>(null);

  const scrollAnchor = useMemo(
    () => <ScrollAnchor anchorRef={anchorRef} />,
    [],
  );

  const scrollToAnchor = useCallback(() => {
    if (anchorRef.current) {
      scrollIntoView(anchorRef.current, {
        block: 'nearest',
        scrollMode: 'if-needed',
      }).finally(noop);
    }
  }, []);

  return [scrollAnchor, scrollToAnchor];
};
